<template>
    <div class="reg-info-table">
        <blade>
            <template v-slot:divider>
                <el-divider content-position="left">注册信息表</el-divider>
            </template>
            <template v-slot:searchAndOther>
                <div style="display: flex">
                    <div></div>
                    <div style="text-align: right; flex: 1">
                        <el-button type="primary" size="mini" @click="handleOpenStoreDrawer">录入</el-button>
                    </div>
                </div>
            </template>
            <template v-slot:drawer>
                <el-drawer :visible.sync="storeDrawer" :direction="direction"
                    :before-close="handleCloseStoreDrawer" size="45%">
                    <template slot="title">
                        <span style="color: #409eff; font-size: large">录入</span>
                    </template>
                    <div style="padding: 0.2em 1.4em;">
                        <el-form :model="regInfoForm" :rules="rules" ref="regInfoForm" label-width="80px">
                            <el-card shadow="always">
                                <div slot="header" class="clearfix">
                                    <span>面试人信息</span>
                                </div>
                                <div>
                                </div>
                            </el-card>
                            <el-card shadow="always" style="margin-top: 0.2rem">
                                <div slot="header" class="clearfix">
                                    <span>面试职位</span>
                                </div>
                                <div style="white-space: nowrap">

                                </div>
                            </el-card>
                            <div style="text-align: right; margin-top: 0.2rem">
                                <el-button type="primary" size="mini" @click="submitForm('regInfoForm')">保存</el-button>
                            </div>
                        </el-form>
                    </div>
                </el-drawer>
            </template>
        </blade>
    </div>
</template>

<script>
import Blade from '../../blade/Blade';
export default {
    name: 'RegInfoTable',
    components: { Blade },
    data() {
        return {
            regInfoForm: {

            },
            rules: {
                // name: [
                //     { required: true, message: "请输入姓名", trigger: "blur" },
                //     {
                //         min: 1,
                //         max: 20,
                //         message: "长度在 1 到 20 个字符",
                //         trigger: "blur",
                //     },
                // ],
                // phone: [
                //     { required: true, message: "请输入手机号", trigger: "blur" },
                //     { validator: checkPhone, trigger: "blur" },
                // ],
                // meetAt: [{ required: true, message: "请选择面试时间", trigger: "blur" }],
                // meet_place: [{ required: true, message: "请选择面试地点", trigger: "blur" }],
                // station: [
                //     {
                //         min: 1,
                //         max: 20,
                //         message: "长度在 1 到 20 个字符",
                //         trigger: "blur",
                //     },
                // ],
                // feishuurl: [
                //     {
                //         min: 1,
                //         max: 200,
                //         message: "长度在 1 到 200 个字符",
                //         trigger: "blur",
                //     },
                // ],
            },
            direction: "rtl",
            storeDrawer: false,
        }
    },
    methods: {
        handleOpenStoreDrawer() {
            this.storeDrawer = true
        },
        handleCloseStoreDrawer(done) {
            // this.$refs.categoryForm.resetFields();
            this.$confirm("确认关闭？")
                .then((_) => {
                    done();
                })
                .catch((_) => { });
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // this.categoryForm.file = this.needUrl;
                    this.$axios
                        .post("api/recruit_manage_store", this.categoryForm)
                        .then((res) => {
                            const { data } = res;
                            if (data.code === 1) {
                                // this.$message.success(data.msg);
                                // this.$refs.categoryForm.resetFields();
                                // this.$bus.$emit("ysyclearrm");
                                // this.categoryIndrawer = false;
                                // this.loadTable();
                            } else {
                                this.$message.error(data.msg);
                            }
                        })
                        .catch();
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/customer/RegInfoTable.vue